import React from "react";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { FilterViewOurNode } from "./filter-view-our-node/filter-view-our-node";
import { useFilterViewOurNodeMachineHook } from "./filter-view-our-node/use-filter-view-our-node-machine-hook";
import { calcContentPaneHeight } from "@src/cloud-connect/utils/calculate-content-pane-height";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

export const TreeViewForFilteredDataMachineStructureOurNode = () => {
  const nodeManager = getNodeManager();

  const transferedNodeData = useSelector(
    (state: RootState) => state.yourSlice.editStructurePageTransferData,
  );

  return (
    <>
      <div
        style={{
          height: calcContentPaneHeight(397),
          overflowY: transferedNodeData ? "scroll" : "hidden",
          overflowX: "hidden",
        }}
      >
        <FilterViewOurNode
          useHook={useFilterViewOurNodeMachineHook}
          updateCheckboxFunc={
            nodeManager.updateMachineStructureListAndFilteredMachineStructureListWithSelectedNode
          }
          type="machine"
          activateDragAndDrop={false}
        />
      </div>
    </>
  );
};
